<div class="page">
  <app-page-header [title]="'admin.clubs.title' | translate" [backLabel]="'admin.dashboard.title' | translate" backLink="/admin/dashboard" />

  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
    @for (region of asArray(clubsByRegion()); track region.key) {
    <div
      class="card min-w-0 overflow-hidden flex flex-col">
      <h2
        class="section-title break-words px-4 py-4 sm:px-6 bg-slate-50 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-800">
        {{ region.key }}
      </h2>
      <ul class="divide-y divide-slate-200 dark:divide-slate-700 overflow-y-auto">
        @for(club of region.value; track club.name) {
        <li
          class="px-4 py-3 sm:px-6 flex min-w-0 items-center gap-3 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
          <div class="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center overflow-hidden shrink-0 text-sm font-black text-slate-400">
            @if (club.logoUrl) {
              <img [src]="club.logoUrl" [alt]="'Logo ' + club.name" class="h-full w-full object-cover">
            } @else {
              {{ club.name.charAt(0) }}
            }
          </div>
          <span class="min-w-0 break-words text-slate-800 dark:text-slate-200 text-sm flex-1">{{ club.name }}</span>
          <label class="shrink-0 cursor-pointer text-xs font-bold text-accent px-2 py-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
            @if (uploadingClubId() === club.id) {
              ...
            } @else {
              {{ 'admin.clubs.changeLogo' | translate }}
            }
            <input type="file" class="hidden" accept="image/*" (change)="onLogoSelected($event, club)" [disabled]="uploadingClubId() !== null">
          </label>
          <span
            class="shrink-0 text-xs font-mono bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 px-2 py-0.5 rounded-full">
            {{ club.departmentCode }}
          </span>
        </li>
        }
      </ul>
    </div>
    }
  </div>
</div>
